<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item>休假管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请输入休假员工名字筛选" style="margin-right: 0; width: 100%;">
              <el-option label="休假员工" value="realname" checked></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="筛选：" prop="type">
          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.dep_id" placeholder="部门" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v.en_name" :value="v.id" v-for="(v, i) in DepartList" :key="i"></el-option>
            </el-select>
          </el-col>

        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="部门"></el-checkbox>
            <el-checkbox label="休假员工"></el-checkbox>
            <el-checkbox label="年假"></el-checkbox>
            <el-checkbox label="婚假"></el-checkbox>
            <el-checkbox label="产假"></el-checkbox>
            <el-checkbox label="陪产假"></el-checkbox>
            <el-checkbox label="调休"></el-checkbox>
            <el-checkbox label="事假"></el-checkbox>
            <el-checkbox label="病假"></el-checkbox>
            <el-checkbox label="丧假"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button @click="exportVacationToExcel" v-if="NodeInclude('375')">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row :row-class-name="tableRowClassName">
        <el-table-column prop="department" label="部门" header-align="center" align="center" min-width="100"
          v-if="check('部门')" />
        <el-table-column prop="staff_realname" label="休假员工" header-align="center" align="center" min-width="120"
          v-if="check('休假员工')">
          <template slot-scope="scope">
            {{ scope.row.staff_realname }} {{ scope.row.staff_en_name }}
          </template>
        </el-table-column>
        <el-table-column prop="annual_days" label="年假" header-align="center" align="center" min-width="100"
          v-if="check('年假')">
          <template slot-scope="scope">
            {{ scope.row.annual_days }}/{{ scope.row.annual_total_days }}
          </template>
        </el-table-column>
        <el-table-column prop="compensatory_days" label="调休" header-align="center" align="center" min-width="100"
          v-if="check('调休')">
          <template slot-scope="scope">
            {{ scope.row.compensatory_days }}
          </template>
        </el-table-column>
        <el-table-column prop="personal_days" label="事假" header-align="center" align="center" min-width="100"
          v-if="check('事假')">
          <template slot-scope="scope">
            {{ scope.row.personal_days }}
          </template>
        </el-table-column>
        <el-table-column prop="sick_days" label="病假" header-align="center" align="center" min-width="100"
          v-if="check('病假')">
          <template slot-scope="scope">
            {{ scope.row.sick_days }}
          </template>
        </el-table-column>
        <el-table-column prop="marriage_days" label="婚假" header-align="center" align="center" min-width="100"
          v-if="check('婚假')">
          <template slot-scope="scope">
            {{ scope.row.marriage_days }}/{{ scope.row.marriage_total_days }}
          </template>
        </el-table-column>
        <el-table-column prop="maternity_days" label="产假" header-align="center" align="center" min-width="100"
          v-if="check('产假')">
          <template slot-scope="scope">
            {{ scope.row.maternity_days }}/{{ scope.row.maternity_total_days }}
          </template>
        </el-table-column>
        <el-table-column prop="maternity_days" label="陪产假" header-align="center" align="center" min-width="100"
          v-if="check('陪产假')">
          <template slot-scope="scope">
            {{ scope.row.paternity_days }}/{{ scope.row.paternity_total_days }}
          </template>
        </el-table-column>
        <el-table-column prop="maternity_days" label="丧假" header-align="center" align="center" min-width="100"
          v-if="check('丧假')">
          <template slot-scope="scope">
            {{ scope.row.bereavement_days }}
          </template>
        </el-table-column>

        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('378')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'vacation',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      checkList: [
        '部门',
        '休假员工',
        '年假',
        '婚假',
        '产假',
        '陪产假',
        '调休',
        '事假',
        '病假',
        '丧假',
      ],
      yearList: [],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'realname',
      },
      DepartList: [],
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.vacationType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '部门',
          val: 'dep_id',
          value: this.dd.department[this.form.dep_id],
          active: !!this.form.dep_id,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {

  },
  mounted() {
    this.getStoreFn()
    this.getDepartmentList()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportVacationToExcel() {
      window.location = api.exportVacationToExcel({
        ...this.form,
        [this.form.atype]: this.form.key,//搜索
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    check(key) {
      return this.checkList.includes(key)
    },

    link(url) {
      this.$router.push(url)
    },

    handleView(item) {
      this.$router.push({
        path: '/vacation/detail',
        query: { uid: item.user_id},
      })
    },

    search() {
      this.p = 1
      store.commit('setVacationData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.vacationData).length != 0 ? store.state.vacationData : this.form
      this.getList()
    },

    getDepartmentList() {
      this.$fly
        .post('apiAccount_getDepartmentList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.DepartList = res
        })
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        [this.form.atype]: this.form.key,//搜索
      }
      api.getHolidayList(postData).then((res) => {
        this.itemList = res.itemList
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.userId = store.state.userId
        }, 200);
      })
    },

    removeTag(tag) {
      if (tag.val === 'expense_amount') {
        this.form.expense_amount_from = undefined
        this.form.expense_amount_to = undefined
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setVacationData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },

    handleCurrentChange(p) {
      this.p = p
      store.commit('setVacationData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    tableRowClassName({ row }) {
      console.log(row.status);
      if (row.staff?.status === "2") {
        return "warning-row";
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.expense {
  @extend %start;
  padding: 30px 0;

  >div {
    margin-right: 30px;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.description {
  @extend %start;

  div {
    &:nth-of-type(1) {
      width: 90px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 150px);
    }

    &:nth-of-type(3) {
      width: 60px;
    }
  }
}

.form-title {
  line-height: 40px;
}

.vaca-form {
  el-form-item {
    .el-form-item__content {
      el-col-8 {
        margin-right: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.el-table tr {
  &.warning-row {
    // background: #d1d1d1;

    .el-table__cell {
      color: #aaa;
    }
  }
}
</style>